import { SEVERITY_PALETTE, type SeverityKey } from "@safers/ui/styles/severity";

export { SEVERITY_LABELS } from "@safers/ui/styles/severity";

export const severityColor = (severity: SeverityKey) => SEVERITY_PALETTE[severity].fill;
export const severityTextColor = (severity: SeverityKey) => SEVERITY_PALETTE[severity].panelFg;
